export const EV_CONFIG_TAG = "EV_LOAD_MANAGEMENT";
export const EV_INSTANT_EVENT_CONFIG_TAG = "EV_INST_EVENT";

export const EV_LOAD_STRINGS: any = {
  TITLE: `${EV_CONFIG_TAG}.EV_LOAD.TITLE`,
  LAST_SYNC: `${EV_CONFIG_TAG}.EV_LOAD.LAST_SYNC`,
  POPUP: {
    TITLE: `${EV_CONFIG_TAG}.EV_LOAD.POPUP.TITLE`,
    MESSAGE: `${EV_CONFIG_TAG}.EV_LOAD.POPUP.MESSAGE`,
    BTN: {
      CANCEL: `${EV_CONFIG_TAG}.EV_LOAD.POPUP.BTN.CANCEL`,
      CONTINUE: `${EV_CONFIG_TAG}.EV_LOAD.POPUP.BTN.CONTINUE`,
    },
  },
  REFRESH_WARNING: `${EV_CONFIG_TAG}.EV_LOAD.REFRESH_WARNING`,
  REFRESH_SUCCESS: `${EV_CONFIG_TAG}.EV_LOAD.REFRESH_SUCCESS`,
  REFRESH_FAILURE: `${EV_CONFIG_TAG}.EV_LOAD.REFRESH_FAILURE`,
};

export const EV_INST_EVENT_STRINGS: any = {
  POPUP_TITLE: `${EV_INSTANT_EVENT_CONFIG_TAG}.POPUP_TITLE`,
  STOP_FOR_MINUTES: `${EV_INSTANT_EVENT_CONFIG_TAG}.STOP_FOR_MINUTES`,
  DESC: `${EV_INSTANT_EVENT_CONFIG_TAG}.DESC`,
  BTN: {
    CANCEL: `${EV_INSTANT_EVENT_CONFIG_TAG}.BTN.CANCEL`,
    CONFIRM: `${EV_INSTANT_EVENT_CONFIG_TAG}.BTN.CONFIRM`,
    INSTANT_STOP_EV_CHARGING: `${EV_INSTANT_EVENT_CONFIG_TAG}.BTN.INSTANT_STOP_EV_CHARGING`,
    STOP_EV: `${EV_INSTANT_EVENT_CONFIG_TAG}.BTN.STOP_EV`,
  },
  LABEL: {
    CONTROLLABLE_EV : `${EV_INSTANT_EVENT_CONFIG_TAG}.LABEL.CONTROLLABLE_EV`,
    DEMAND_DROP : `${EV_INSTANT_EVENT_CONFIG_TAG}.LABEL.DEMAND_DROP`,
    LAST_SYNC_AT : `${EV_INSTANT_EVENT_CONFIG_TAG}.LABEL.LAST_SYNC_AT`,
    SELECT_MINUTES: `${EV_INSTANT_EVENT_CONFIG_TAG}.LABEL.SELECT_MINUTES`,
  },
  UNIT: {
    CONTROLLABLE_EV : `${EV_INSTANT_EVENT_CONFIG_TAG}.UNIT.CONTROLLABLE_EV`,
    DEMAND_DROP : `${EV_INSTANT_EVENT_CONFIG_TAG}.UNIT.DEMAND_DROP`,
    LAST_SYNC_AT : `${EV_INSTANT_EVENT_CONFIG_TAG}.UNIT.LAST_SYNC_AT`,
    SELECT_MINUTES: `${EV_INSTANT_EVENT_CONFIG_TAG}.UNIT.SELECT_MINUTES`,
  },
  SCHEDULE_INFO : `${EV_INSTANT_EVENT_CONFIG_TAG}.SCHEDULE_INFO`,
};
